export const buttonOverrides = (buttons) => {
    return `
        .video-js .vjs-fullscreen-control {
            ${buttons.fullscreen === false ? 'display: none' : ''}
        }

        .video-js .vjs-time-control {
            ${buttons.currenttime === false ? 'display: none' : ''}
        }

        .video-js .vjs-progress-control {
            ${buttons.progressbar === false ? 'display: none' : ''}
        }

        .video-js .vjs-subs-caps-button {
            ${buttons.closedcaption === false ? 'display: none' : ''}
        }

        .video-js .vjs-big-play-button {
            ${buttons.showLargePlayButton === false ? 'display: none !important' : ''}
        }

        .video-js .vjs-control-bar {
            ${buttons.controlBar === false ? 'display: none' : 'display: flex'};
        }

        .video-js .vjs-mute-control {
            ${buttons.volumeIndicator === false ? 'display: none' : ''};
        }
        
        .video-js .vjs-play-control {
            ${buttons.playButton === false ? 'display: none' : ''};
        }

    `;
}
